import { useCallback } from 'react';
import { toast } from 'react-hot-toast';
import { useTranslation } from 'react-i18next';
import type { ViewModelId } from 'balus-common';
import { useRequiredCurrentUserId } from '@framework/auth';
import { PrivateAIAssistantChatThreadRepository } from '@view-model/application/ai/PrivateAIAssistantChatRepository';
import { useAIAssistantRouter, useRequestAIAssistantThread } from './aiAssistantRouteAtom';

// 新しいスレッドを発行してチャット画面へ遷移する
export const useStartNewAIAssistantChat = (viewModelId: ViewModelId): (() => void) => {
  const { t } = useTranslation();
  const userId = useRequiredCurrentUserId();
  const router = useAIAssistantRouter(viewModelId);
  const requestThread = useRequestAIAssistantThread(viewModelId);

  return useCallback(() => {
    try {
      requestThread(PrivateAIAssistantChatThreadRepository.generateThreadId(viewModelId, userId));
      router.push({ page: 'chat' });
    } catch (err) {
      console.error('Failed to start new AI assistant chat', err);
      toast.error(t('viewModel.aiChat.toastCreateThreadError'));
    }
  }, [requestThread, router, t, userId, viewModelId]);
};
